import { lazy } from 'react';

export const ManageDeals = lazy(() => import('../containers/seller/CreateDeals'));
export const SellerLogin = lazy(() => import('../containers/seller/login'));
export const SellerRegister = lazy(() => import('../containers/seller/Register'));
export const SellerResetPwd = lazy(() => import('../containers/seller/ResetPassword'));
export const SellerForgotPwd = lazy(() => import('../containers/seller/ForgotPassword'));
export const ProductStockManagement = lazy(() => import('../containers/seller/ProductStockManagement'));
export const SellerChat = lazy(() => import('../containers/seller/Chat'));
export const ServiceStockManagement = lazy(() => import('../containers/seller/ServiceStockManagement'));
export const AddProduct = lazy(() => import('../containers/seller/AddProduct'));
export const AddService = lazy(() => import('../containers/seller/AddService'));
export const SellerDashboard = lazy(() => import('../containers/seller/SellerDashboard'));
export const ProductOrders = lazy(() => import('../containers/seller/ProductOrders'));
export const ServiceOrders = lazy(() => import('../containers/seller/ServiceOrders'));
export const ListedProducts = lazy(() => import('../containers/seller/ListedProducts'));
export const Contact = lazy(() => import('../containers/seller/Contact'));
export const Payments = lazy(() => import('../containers/seller/Payments'));
export const SellerProductDetail = lazy(() => import('../containers/seller/ProductDetail'));
export const SellerServiceDetail = lazy(() => import('../containers/seller/ServiceDetail'));
export const SellerOrderDetail = lazy(() => import('../containers/seller/OrderDetail'));
export const SellerManageBannerAdvertisement = lazy(() => import('../containers/seller/ManageBannerAdvertisement'));
export const SellerBannerList = lazy(() => import('../containers/seller/ManageBannerList'));
export const SellerBannerEdit = lazy(() => import('../containers/seller/ManageBannerListEdit'));
export const SellerManageSubscription = lazy(() => import('../containers/seller/ManageSubscriptionPlan'));
export const SellerCommunity = lazy(() => import('../containers/community/sellerCommunity'));
export const EditService = lazy(() => import('../containers/seller/EditService'));
export const ServiceCheckoutStripe = lazy(() => import('../containers/seller/ServiceCheckoutStripe'));
export const EditProduct = lazy(() => import('../containers/seller/EditProduct'));
export const SellerNotifications = lazy(() => import('../containers/seller/Notifications'));
export const SellerProfile = lazy(() => import('../containers/community/SellerProfile'));
export const SellerSharePostData = lazy(() => import('../components/community/common/SellerSharePostData'));
export const SupportSeller = lazy(() => import('../containers/seller/SupportSeller'));
export const SupportSellerEmail = lazy(() =>
    import('../containers/seller/SupportSellerEmail').then((module) => ({
        default: module.SupportSellerEmail,
    }))
);
export const SupportSellerCall = lazy(() =>
    import('../containers/seller/SupportSellerCall').then((module) => ({
        default: module.SupportSellerCall,
    }))
);
export const SellerMyProfile = lazy(() =>
    import('../containers/seller/SellerMyProfile').then((module) => ({
        default: module.SellerMyProfile,
    }))
);
export const SupportTicketSeller = lazy(() => import('../containers/seller/SupportTicketSeller'));
export const SupportTicketChat = lazy(() => import('../containers/seller/SupportTicketChat'));
export const SellerStripeOnboarding = lazy(() => import('../containers/seller/SellerStripeOnboarding'));
export const SellerTaxSettings = lazy(() => import('../containers/seller/SellerTaxSettings'));
export const SellerProjectsList = lazy(() => import('../containers/seller/SellerProjectsLists'));
export const SellerProjectDetails = lazy(() => import('../containers/seller/SellerProjectDetails'));
export const QuoteManagement = lazy(() => import('../containers/seller/QuoteManagement'));
export const SellerEarnings = lazy(() => import('../containers/seller/SellerEarnings'));
export const SellerWithdrawal = lazy(() => import('../containers/seller/SellerWithdrawal'));
export const SellerLicenses = lazy(() => import('../containers/seller/SellerLicenses'));
export const SellerTeamManagement = lazy(() => import('../containers/seller/SellerTeamManagement'));
